'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import UIForm from 'UIComponents/form/UIForm';
export default class DropdownForm extends PureComponent {
  render() {
    const _this$props = this.props,
          {
      children,
      className
    } = _this$props,
          rest = _objectWithoutPropertiesLoose(_this$props, ["children", "className"]);

    const formClasses = classNames('dropdown-form', className);
    return /*#__PURE__*/_jsx(UIForm, Object.assign({
      className: formClasses
    }, rest, {
      children: children
    }));
  }

}
DropdownForm.displayName = 'DropdownForm';
DropdownForm.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};
DropdownForm.defaultProps = {
  children: null,
  className: ''
};